import React from "react";
import arrow from "../../assets/icons/arrow.png";

/**
 * Reusable back button component
 * @param {string} text - The text to display (defaults to "Back")
 * @param {Function} onClick - Click handler function
 * @param {string} className - Additional CSS classes
 */
function BackButton({ text = "Back", onClick, className = "" }) {
  return (
    <button
      onClick={onClick}
      className={`bg-gray-200 dark:bg-gray-700 w-full flex flex-row justify-center items-center gap-2 h-10 p-5 rounded-full hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors ${className}`}
    >
      <img src={arrow} alt="Back" className="h-4 w-4 dark:invert" />
      <h5 className="text-gray-900 dark:text-gray-200 font-bold text-sm text-center w-full">
        {text}
      </h5>
    </button>
  );
}

export default BackButton;
